import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'


const routes: Array<RouteRecordRaw> = [
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/AuthView.vue'),
    // meta: {
    //   title: '熊猫AI校园'
    // }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/UserView.vue')
  },
  
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/MyView.vue'),
    // meta: {
    //   title: '我的'
    // }
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/PersonalView.vue')
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('../views/UsAboutView.vue')
  },
  {
    path: '/set',
    name: 'set',
    component: () => import('../views/SetView.vue')
  },
  {
    path: '/selectschool',
    name: 'selectschool',
    component: () => import('../views/SelectschoolView.vue')
  },
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import('../views/AuthenticationView.vue')
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('../views/SuccessView.vue')
  },

  {
    path: '/safeset',
    name: 'safeset',
    component: () => import('../views/SafesetView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
 

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
console.log(router, 'router')
export default router
